/*! *********************************************************************
 *
 * Copyright 2019 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */

import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import ActionEdit from '@material-ui/icons/Edit';
import { Button } from '@material-ui/core';
import PreviewDialogEdit from './PreviewDialogEdit';

const styles = (theme) => ({
  extendedIcon: {
    marginRight: theme.spacing(),
  },
});

class EditPreviewButton extends Component {
  state = {
    open: false,
  };

  openDialog = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  onValidated = (preview) => {
    this.props.onChange(preview);
    this.handleClose();
  };

  getDialogProps = () => ({
    open: this.state.open,
    record: this.props.record,
    onValidated: this.onValidated,
    close: this.handleClose,
    assetType: this.props.assetType,
  });

  render() {
    const { classes = {} } = this.props;
    return (
      <React.Fragment>
        <Button size="small" color="primary" onClick={this.openDialog}>
          <ActionEdit className={classes.extendedIcon} />
          {this.props.label}
        </Button>
        <PreviewDialogEdit {...this.getDialogProps()} />
      </React.Fragment>
    );
  }
}

EditPreviewButton.defaultProps = {
  onChange: () => {},
  label: 'Actions',
};

export default withStyles(styles)(EditPreviewButton);
